module.exports = __webpack_public_path__ + "assets/img/36_504.34507869.jpg";